import React from 'react';
import DEFAULT_ITEM from '../assets/defaults/restaurant-logo-default-256.png';

const RestaurantLogo = ({ src, alt, className, ...rest }) => {
    const handleError = (e) => {
        e.target.onerror = null;
        e.target.src = DEFAULT_ITEM;
    };

    return (
        <img
            src={src || DEFAULT_ITEM}
            alt={alt || "Restaurant Logo"}
            className={className}
            onError={handleError}
            {...rest}
        />
    );
};

export default RestaurantLogo;
